const state = () => {
    return {
        scales: [],
        scale_houses: [],
        scale_measurements: [],
        weighing_on_scale_types: {},
        weighing_on_scale_vehicle_conf: {},
    }
}

export default state;
